const PropTypes = require('prop-types');
const React = require('react');
const { Tracker } = require('@reverbdotcom/discovery-ui');

class RelatedArticle extends React.Component {
  get categoryName() {
    return this.props.article.categories
      && this.props.article.categories[0]
      && this.props.article.categories[0].name;
  }

  get linkWithAid() {
    return `${this.props.article._links.web.href}?_aid=listingrelatedarticle`;
  }

  trackClick() {
    Tracker.trackInteraction({
      name: 'RelatedArticleCard',
      url: this.props.article._links.web.href,
      type: 'article',
      id: `${this.props.article.id}`,
      clientSide: false,
    });
  }

  render() {
    return (
      <article className="article-condensed-card">
        <a
          href={this.linkWithAid}
          style={{ backgroundImage: `url(${this.props.article.photo})` }}
          onClick={() => this.trackClick()}
        >
          <div className="article-condensed-card__title">
            {this.props.article.title}
          </div>
          <div className="article-condensed-card__category">
            {this.categoryName}
          </div>
        </a>
      </article>
    );
  }
}

RelatedArticle.propTypes = {
  article: PropTypes.object.isRequired,
};

module.exports = RelatedArticle;



// WEBPACK FOOTER //
// ./javascripts/components/shared/related_article.jsx